import shared from '~shared'

export default {
  login(login, password){
    return shared.getRequest().post('/user_session.json', {
      user_session: {login, password}
    })
    .then(result => {
      return result.data
    })
  }
}



// WEBPACK FOOTER //
// ./src/login/server.js